import { HttpAuth, HttpUpload } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'

export const actionTypes = {
    INDEX: 'APP_INDEX',
    UPDATE: 'APP_UPDATE',
    CHANGE: 'APP_CHANGE',
    CHANGE_THEME: 'APP_CHANGE_THEME',
    CHANGE_USER: 'APP_CHANGE_USER',
    ERROR: 'APP_ERROR',
    SUCCESS: 'APP_SUCCESS'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const changeTheme = (payload) => ({
    type: actionTypes.CHANGE_THEME,
    payload
})

export const changeUser = (payload) => ({
    type: actionTypes.CHANGE_USER,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

/* LOGOUT */

export const logout = (all = null) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.get('/logout'+ (all ? '/all' : ''))
            .then(res => {
                dispatch(changeLoading({ open: false }))
                
                if(typeof res !== 'undefined') {
                    if(res.data.success === 200) {
                        dispatch(changeNotify({
                            open: true,
                            msg: res.data.msg,
                            class: 'success'
                        }))
                        localStorage.removeItem('access_token')
                        setTimeout(() => window.location.replace('/login'), 1500)
                    }
                }
            })
}

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = () => dispatch => {
    return HttpAuth.get('/app')
            .then(res => res && dispatch(indexResponse(res.data)))
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/app/'+(data.id), data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(updateResponse(data))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                    setTimeout(() => dispatch(success(true)), 1000)
                }
            }
        })
        .catch(erro => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof erro.response !== 'undefined') {
                if(erro.response.status === 400) {
                    if(typeof erro.response.data === 'object'){
                        
                        if(typeof erro.response.data.error !== undefined) {
                            if(typeof erro.response.data.error === 'string'){
                                dispatch(error(erro.response.data.error))
                                dispatch(changeNotify({
                                    open: true,
                                    msg: 'Preencha os campos obrigatórios',
                                    class: 'error'
                                }))
                            }
                        }
                        dispatch(changeLoading({ open: false }))
                    }
                }
            }
        })
}

/* UPDATE USER */

export const updateUser = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/user', data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    setTimeout(() => {
                        dispatch(success(true))
                        dispatch(changeUser({password: ''}))
                    }, 1000)
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// UPLOAD LOGO

export const upload = (item) => dispatch => {
    return HttpUpload.post('upload/logo', item)
        .then(res => res && dispatch(change(res.data)))
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.logo) {
                    dispatch(changeNotify({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            return dispatch(changeLoading({ open: false }))
        })
}

// UPLOAD CAPITALIZADORA

export const uploadCapitalizer = (item) => dispatch => {
    return HttpUpload.post('upload/capitalizer', item)
        .then(res => res && dispatch(change(res.data)))
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.capitalizer_logo) {
                    dispatch(changeNotify({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            return dispatch(changeLoading({ open: false }))
        })
}

// DELETE CAPITALIZADORA

export const deleteCapitalizerResponse = (payload) => ({
    type: actionTypes.DELETE_PHOTO,
    payload
})

export const deleteCapitalizer = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('upload/capitalizer/'+id)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.error) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.error,
                        class: 'error'
                    }))
                }
                
                if(res.data.success) {
                    dispatch(change({
                        capitalizer_logo: null
                    }));
                }
            }
        }).catch(() => dispatch(changeLoading({ open: false })))
}